import { Controller } from "@hotwired/stimulus"

// Admin → Companies: the Deleted tab's Restore button (Phelipe 2026-09-25,
// "the same feature as Users"). Confirms in a modal, posts the restore, and
// takes the row out of the list without a reload.
export default class extends Controller {
  static targets = ["restoreModal", "restoreName", "restoreConfirmBtn"]

  showRestoreModal(event) {
    const btn = event.currentTarget
    this._restoreUrl = btn.dataset.restoreUrl
    this._restoreCompanyId = btn.dataset.companyId
    this.restoreNameTarget.textContent = btn.dataset.companyName
    this.restoreModalTarget.classList.remove("hidden")
  }

  hideRestoreModal() {
    this.restoreModalTarget.classList.add("hidden")
  }

  async confirmRestore() {
    const btn = this.restoreConfirmBtnTarget
    btn.disabled = true
    btn.textContent = "Restoring…"
    try {
      const response = await fetch(this._restoreUrl, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        }
      })
      const data = await response.json().catch(() => ({}))
      this.hideRestoreModal()
      if (response.ok) {
        this._removeDeletedRow(this._restoreCompanyId)
        this._showToast(data.message || "Company restored.")
      } else {
        this._showToast(data.error || "Could not restore this company. Please try again.", "alert")
      }
    } catch (error) {
      this.hideRestoreModal()
      this._showToast("Could not restore this company. Please try again.", "alert")
    } finally {
      btn.disabled = false
      btn.textContent = "Restore"
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _removeDeletedRow(companyId) {
    const row = this.element.querySelector(`tr[data-deleted-company-row][data-company-id="${companyId}"]`)
    if (!row) return
    const tbody = row.closest("tbody")
    row.remove()
    if (tbody && !tbody.querySelector("tr[data-deleted-company-row]")) {
      const tr = document.createElement("tr")
      tr.innerHTML = `<td colspan="5" class="text-center py-8 text-sm text-text-muted">No deleted companies.</td>`
      tbody.appendChild(tr)
    }
  }

  _showToast(message, type = "notice") {
    const toast = document.createElement("div")
    toast.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    toast.setAttribute("data-controller", "flash")
    toast.setAttribute("data-flash-dismiss-after-value", "5000")
    toast.innerHTML = `<span>${message}</span>
      <button type="button" data-action="click->flash#dismiss" class="ml-3 text-white/80 hover:text-white cursor-pointer">&times;</button>`
    document.body.prepend(toast)
  }
}
